import { render, staticRenderFns } from "./TaxDisc.vue?vue&type=template&id=f9bcb65a&scoped=true&"
import script from "./TaxDisc.vue?vue&type=script&lang=js&"
export * from "./TaxDisc.vue?vue&type=script&lang=js&"
import style0 from "./TaxDisc.vue?vue&type=style&index=0&id=f9bcb65a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9bcb65a",
  null
  
)

export default component.exports